<template>
  <div class="calendar-legend">
    <ul>
      <li class="closed-whole-day">Closed (whole day)</li>
      <li class="closed-breakfast">Closed for breakfast {{ modeDisplay }}</li>
      <li class="closed-lunch">Closed for lunch {{ modeDisplay }}</li>
      <li class="closed-evening">Closed for evening {{ modeDisplay }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'CalendarLegend',
  props: ['mode'],
  data() {
    return {
    }
  },
  computed: {
    modeDisplay() {
      if (this.mode == 'delivery') {
        return 'deliveries'
      }

      return 'pickups'
    }
  },
  methods: {
  },
}
</script>
<style lang="scss">
.calendar-legend {
  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 1rem 0;

    li {
      position: relative;
      padding-left: 30px;
    }
    li::before {
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }

    li.closed-whole-day::before {
      background-color: #f0ae9e;
    }
    li.closed-breakfast::before {
      background-color: #f5dc73;
    }
    li.closed-lunch::before {
      background-color: #c6db8a;
    }
    li.closed-evening::before {
      background-color: #a2dee0;
    }
  }
}
</style>
